import axios from "axios";
import { baseURL } from "../config/api";

export const post_ProcessSquareTerminalPayment = (appointmentId: number, amount: number, userId: number) => {
    return axios({
        url: `${baseURL}payments/StartSquareTerminalPayment,${appointmentId},${amount},${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false
    }).then(response => response.data);
}

export const post_ProcessPaymentByOffline = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}payments/ProcessPaymentByOffline?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const getAllCreditCard = () => {
    return getFetch(`creditCard/allcards`)
}

export const getAppointmentPaymentHistory = (id: number) => {
    return getFetch(`payments/GetPaymentsByAppointmentId/${id}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}